import {SearchDataConstants} from "../../core/common/search-data-constants";

export class SystemSwitchUtils {

  static getSystemSwitchMsgMlocationSearchData() {
    const systemSwitchSearchText = sessionStorage.getItem(SearchDataConstants.SYS_SWITCH_METER_SEARCH);
    return systemSwitchSearchText || '';
  }
}
